/**
 * @file index.tsx
 *
 * @fileoverview helper functions for resume analytics events.
 */

import { DIMENSIONS, setEventParams } from '~/jobiqo/lib/analytics';
import { User } from '~/jobiqo/models/user';
import { Resume } from '~/jobiqo/types/types';
import { concatArrayItems } from '~/jobiqo/utils/mapper';

/**
 * Returns the dimensions for a given resume.
 *
 * @param {Resume} resume
 *   The resume to return dimensions for.
 * @param {User} user
 *   Current user.
 * @returns {Object}
 *   The dimensions object for this resume.
 */
export const getResumeDimensions = (resume: Resume, user: User) =>
  setEventParams({
    [DIMENSIONS.entity_id]: resume.id,
    [DIMENSIONS.entity_type]: 'profile',
    [DIMENSIONS.entity_subtype]: 'resume',
    [DIMENSIONS.title]: resume.title,
    [DIMENSIONS.current_user_id]: user?.id,
    [DIMENSIONS.user_role]: concatArrayItems(user?.roles, 'targetId'),
    [DIMENSIONS.prefered_job_role]:
      resume?.desiredOccupation?.map(String).join(', ') ?? '',
  });
